module.exports = __webpack_public_path__ + "static/media/1-male.ccf099c3.png";